import { render, staticRenderFns } from "./ActionCopy.vue?vue&type=template&id=600cd082&scoped=true&"
import script from "./ActionCopy.vue?vue&type=script&lang=js&"
export * from "./ActionCopy.vue?vue&type=script&lang=js&"
import style0 from "./ActionCopy.vue?vue&type=style&index=0&id=600cd082&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600cd082",
  null
  
)

export default component.exports